import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  Text,
} from "@fluentui/react-components";
import { Dismiss16Regular } from "@fluentui/react-icons";
import { useStyles } from "./copiedLinkDialog.styles";
import { ICopiedLinkDialogProps } from "./copiedLinkDialog.types";

export const CopiedLinkDialog = (
  props: ICopiedLinkDialogProps,
): JSX.Element => {
  const { open, onClose } = props;
  const styles = useStyles();

  return (
    <Dialog
      open={open}
      onOpenChange={(_, data) => {
        if (!data.open) {
          onClose();
        }
      }}
    >
      <DialogSurface className={styles.dialogSurface}>
        <div className={styles.headerRow}>
          <Text weight="semibold" size={200} className={styles.headerText}>
            Copied!
          </Text>

          <Button
            appearance="subtle"
            size="small"
            icon={<Dismiss16Regular />}
            onClick={onClose}
            className={styles.closeButton}
          />
        </div>

        <DialogBody className={styles.body}>
          <DialogContent>
            <Text className={styles.bodyText}>
              The link was copied to your clipboard.
            </Text>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
